import type { ImageNaturalSize } from "@/hooks/use-image-natural-size"

export function ImageResolutionLabel({ size }: { size: ImageNaturalSize | null }) {
  if (!size) return null
  return (
    <span className="hidden text-xs text-ui-text-secondary tabular-nums sm:inline">
      {size.w}&times;{size.h}
    </span>
  )
}
